<template>
  <div class="DetailHead-container">
    <div class="gb-wrap clearfix">
      <!-- <a class="head-img" href="/" @click.prevent="$router.push('/')"> -->
      <router-link tag="a" to="/" class="head-img">
        <img alt="木夕logo" src="@/assets/logo.png" />
      </router-link>
      <div class="gb-menu" v-if="cpIsMenu">
        <!-- <span
          style="padding:32px 24px;"
          :class="{ active: index === activeIdx }"
          v-for="(item, index) in ['产品介绍', '产品图片']"
          :key="item"
          @click="scrollTo(index)"
          >{{ item }}</span
        > -->
        <!-- <span style="padding:32px 24px;" :class="{ active: index === activeIdx }" v-for="(item, index) in [ '首页', '发布信息', '推广信息']" :key="item" @click="handleClick(index)">{{ item }}</span> -->
      </div>

      <!--
      <el-input placeholder="" v-model="input3" style="width:400px;margin:10px 0   0 100px;" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>-->

      <!-- <div class="head-info"> -->
        <!-- <div class="gb-search" v-if="cp_isSearch">
          <input type="text" v-model="dt_searchText" placeholder="请输入搜索作品名称" @keypress="fn_search" />
          <i class="el-icon-search" @click="fn_search('click')"></i>
        </div> -->
        <!-- <div class="head-info-group" v-if="hasLogin">
          <img class="head-info-icon my-crystal-icon" src="@/assets/crytal_blue.png" />
          <p class="ut-fl">{{ crystalNum }}</p>
        </div> -->
        <!-- <div class="head-info-group ut-cp ut-marl_15">
          <div v-if="hasLogin" class="my-haslogin" @click="toggleMenu(true)">
            <img
              class="head-info-icon"
              :src="
                vx_userInfo.avatar.indexOf('http') == 0
                  ? vx_userInfo.avatar
                  : 'http://mxcdn.muccyapi.com/' + vx_userInfo.avatar
              "
            />
            <p class="head-info-name ut-text-overflow">
              {{ vx_userInfo.nickName }}
              <i class="my-tick">▲</i>
            </p>
          </div>
          <div v-else class="my-notlogin" @click="vx_toggleLogin(true)">
            <img class="head-info-icon" src="@/assets/avatar.png" />
            <p class="head-info-name ut-text-overflow">登录</p>
          </div>
        </div> -->
        <!-- <div v-if="isShowMenu" class="head-info-menu"> -->
          <!-- <div class="head-info-item ut-cp" @click="$router.push('/userCenter')">个人中心</div> -->
          <!-- <router-link tag="div" class="head-info-item ut-cp" to="/userCenter"
            >个人中心</router-link
          >
          <div class="head-info-item ut-cp" @click="vx_toggleLogin(true)">切换账号</div>
          <div class="head-info-item ut-cp" @click="fn_doLogout">注销</div>
        </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'DetailHead',
  components: {},
  data() {
    return {
      isShowMenu: false,
      dt_searchText: '',
      activeIdx: 0,
      activeList: ['RecruitList', 'RecruitAdd', 'PromoInform']
    }
  },
  computed: {
    ...mapState(['vx_userInfo', 'vx_searchText']),
    hasLogin() {
      return !!this.vx_userInfo
    },
    crystalNum() {
      return (this.vx_userInfo || {}).crystalNum
    },
    cp_isSearch() {
      return ['search', 'home'].includes(this.$route.name)
    },
    cpIsMenu() {
      return ['home'].includes(this.$route.name)
      // return ['RecruitList', 'RecruitDetail', 'RecruitAdd', 'PromoInform'].includes(
      //   this.$route.name
      // )
    }
  },
  created() {
    if (this.$route.name == 'search') {
      this.dt_searchText = this.vx_searchText
    } else {
      this.vx_set_searchText('')
    }
    const index = this.activeList.findIndex(i => i === this.$route.name)
    this.activeIdx = index > -1 ? index : 0
  },
  watch: {
    '$route.name': {
      handler(val) {
        const index = this.activeList.findIndex(i => i === val)
        this.activeIdx = index > -1 ? index : 0
      }
    }
  },
  methods: {
    ...mapMutations(['vx_setData', 'vx_toggleLogin', 'vx_doLogout', 'vx_set_searchText']),
    ut_closest(el, selector) {
      var matchesSelector =
        el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector
      while (el) {
        if (matchesSelector.call(el, selector)) {
          break
        }
        el = el.parentElement
      }
      return el
    },
    fnListener() {
      // let el = this.ut_closest(e.target, '.head-info-menu')
      this.$nextTick(() => this.toggleMenu(false))
    },
    toggleMenu(reverse = !this.isShowMenu) {
      this.isShowMenu = reverse
      let fn = reverse ? 'addEventListener' : 'removeEventListener'
      setTimeout(() => document[fn]('click', this.fnListener))
    },
    // 搜索作品
    fn_search(ev) {
      if (ev == 'click' || ev.which == 13) {
        if (!this.dt_searchText) {
          this.$message.error('请输入搜索内容')
          return
        }
        this.vx_set_searchText(this.dt_searchText)
        if (this.$route.name != 'search') {
          this.$router.push({ name: 'search', params: { type: this.$route.name } })
        }
      }
    },
    fn_doLogout() {
      this.vx_doLogout()
      if (this.$route.path.indexOf('userCenter') != -1) {
        this.$router.push('/')
      }
    },
    scrollTo(index) {
      document
        .querySelectorAll('.my-title-cn')
        [index].scrollIntoView({ behavior: 'smooth', block: 'start' })
      this.activeIdx = index
    },
    handleClick(index) {
      if (index === 1 && !this.hasLogin) {
        this.vx_toggleLogin(true)
      } else {
        this.activeIdx = index
        const name = this.activeList[index]
        this.$router.push({ name }).catch()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.DetailHead-container {
  height: 81px;
  line-height: 81px;
  background: #121a28;
  color: #ccc;
  font-size: 16px;
  // overflow: hidden;
}

.gb-wrap {
  padding-top: 10px;
  height: 81px;
  line-height: 81px;
  vertical-align: middle;
}

.head-img {
  float: left;
  height: 81px;
  cursor: pointer;
  line-height: 81px;
  margin-top: -10px;
  img {
    height: 40px;
    vertical-align: middle;
  }
}

.head-info {
  float: right;
  padding-top: calc((60px - 28px) / 2);
  line-height: 28px;
}

.my-tick {
  position: absolute;
  // top: 2px;
  width: 20px;
  text-align: center;
  transform: rotate(180deg);
}

.head-info-group {
  position: relative;
  float: left;
}

.head-info-icon {
  float: left;
  width: 28px;
  height: 28px;
  margin-right: 10px;
  border-radius: 50%;
  &.my-crystal-icon {
    width: 18px;
    height: 18px;
    margin-top: 5px;
    margin-right: 5px;
  }
}

.head-info-name {
  max-width: 6em;
  margin-right: 20px;
}

.head-info-menu {
  position: absolute;
  right: 0;
  top: 70px;
  // background: #D8D8D8;
  font-size: 16px;
  color: #333333;
  z-index: 99;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.head-info-item {
  padding: 15px 20px;
  text-align: center;
  &:hover {
    opacity: 0.5;
  }
}
.gb-menu {
  position: absolute;
  height: 60px;
  line-height: 60px;
  left: 240px;
  cursor: pointer;
  .active {
    background: #4b85ff;
    color: #fff;
  }
}

.gb-search {
  // position: absolute;
  // left: 720px;
  // top: 24px;
  float: left;
  width: 290px;
  height: 36px;
  line-height: 36px;
  margin-top: -4px;
  margin-right: 15px;
  display: flex;
  background: #fff;
  border-radius: 15px;
  input {
    flex: 1;
    margin-left: 20px;
    padding-right: 10px;
    display: block;
    border: 0 none;
    font-size: 14px;
    background: transparent;
    border: 0; // 去除未选中状态边框
    outline: none; // 去除选中状态边框
  }
  i {
    cursor: pointer;
    width: 50px;
    text-align: center;
    line-height: 36px;
  }
}
</style>
